import { Box, Button, Grid, Typography } from '@material-ui/core';
import React, { FC, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { isPhone } from '../../services/deviceService';
import './FinalSteps.scss';
import TenantContext from '../../contexts/tenantContext';

const FinalSteps: FC = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const history = useHistory();
  const tenant = useContext(TenantContext);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  const handleNext = () => {
    if (activeStep === tenant.finalSteps.length - 1)
      history.push("/login");

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <div className="FinalSteps" data-testid="FinalSteps">
      <div>
        <Box height="20vh"></Box>
        <Typography variant="h5" className="message"><span className="ft-35"
          dangerouslySetInnerHTML={{ __html: tenant.finalSteps[activeStep] || "" }} />
          {activeStep === 1 && <span className="ft-35">
            You will be emailed your certificate when it is ready.
          </span>}
        </Typography>
        <Box height="15vh"></Box>
      </div>
      <div className="buttons-row flex-row-reverse">
        <Button
          id='next-btn'
          className="green-button"
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          {activeStep === tenant.finalSteps.length - 1 ? 'Finish' : 'I understand'}
        </Button>
         {activeStep >= 2 &&
          <Button
            id='back-btn'
            className="green-button back-button-v2"
            variant="contained"
            color="primary"
            onClick={handleBack}
          >
            Back
          </Button>
          }
      </div>
    </div>
  );
}


export default FinalSteps;
